<template>
  <div>
    <download-excel
      style="width: 100px"
      :data="data1"
      :fields="json_fields"
      type="xls"
      name="兑换订单图表.xls"
      :fetch="startDownload"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
        Excel导出
      </a-button>
    </download-excel>
    <a-table
      :columns="columns"
      :row-key="(record) => record.userUid"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <template slot="isReceive" slot-scope="text, isReceive">
        <span>{{ isReceive.isReceive === 0 ? "否" : "是" }}</span>
        <!-- <span v-else>{{
          isReceive.isReceive === 1 ? "领取" : "qu"
        }}</span> -->
      </template>
      <template slot="orderStatus" slot-scope="text, orderStatus">
        <span v-if="orderStatus.orderStatus === 0">待领取</span>
        <span v-else>{{
          orderStatus.orderStatus === 2 ? "确认领取" : "取消领取"
        }}</span>
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <span v-if="operate.orderStatus === 2">
          <a
            class="test"
            href="javascript:;"
            v-on:click.prevent="
              topage(`/home/exchangeOrderDetails?orderNo=${operate.orderNo}`)
            "
            >订单详情</a
          >
        </span>
        <span v-else>
          <a
            href=""
            v-on:click.prevent="
              topage(`/home/exchangeOrderDetails?orderNo=${operate.orderNo}`)
            "
            >订单详情</a
          >
          <a href="javascript:;" @click="exchangeok(operate)">确认领取</a>
          <a href="javascript:;" @click="exchangeno(operate)">取消订单</a>
        </span>
        <a-modal
          v-model="visible"
          title="绑定上级"
          @ok="handleOk"
          :maskStyle="{ opacity: 0.1 }"
          cancelText="取消"
          okText="确定"
        >
          <span>uid/手机号码</span>
          <a-input placeholder="Basic usage" />
        </a-modal>
      </template>
    </a-table>
  </div>
</template>
<script>
import { exchangeList } from "@/api/orderApi.js";
import { exchangeOk, exchangeNo } from "@/api/homeApi.js";
import { message } from "ant-design-vue";

const columns = [
  {
    title: "编号",
    dataIndex: "orderNo",
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "用户昵称",
    dataIndex: "userName",
    align: "center",
  },
  {
    title: "用户手机号码",
    dataIndex: "userPhone",
    align: "center",
  },
  {
    title: "支付彩票",
    dataIndex: "payLottery",
    align: "center",
    scopedSlots: { customRender: "payLottery" },
  },
  {
    title: "所属门店",
    dataIndex: "shopName",
    align: "center",
    scopedSlots: { customRender: "shopName" },
  },
  {
    title: "是否领取",
    dataIndex: "isReceive",
    align: "center",
    scopedSlots: { customRender: "isReceive" },
  },
  {
    title: "订单状态",
    dataIndex: "orderStatus",
    scopedSlots: { customRender: "orderStatus" },
  },
  {
    title: "支付时间",
    dataIndex: "createTime",
    align: "center",
  },
  {
    title: "操作",
    dataIndex: "operate",
    scopedSlots: { customRender: "operate" },
  },
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      json_fields: {
        编号: "orderNo",
        用户呢称: "userName",
        用户手机号码: "userPhone",
        支付彩票: "payLottery",
        所属门店: "shopName",
        是否领取: "isReceive",
        订单状态: "orderStatus",
        支付时间: "createTime",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      visible: false,
    };
  },
  mounted() {
    this.getExchangeListData();
  },
  props: ["formInline"],
  methods: {

    async startDownload(){
      // 构建查询参数，使用当前的筛选条件
      const params = {
        ...this.formInline,
        page: 1,
        limit: 1
      };

      
      // 第一步：获取总数量，判断数据规模
      const countRes = await exchangeList(params);
      const totalCount = countRes.count || 0;
      
      if (totalCount === 0) {
        this.$message.warning('当前筛选条件下没有数据可导出');
        return [];
      }
      
      // 第二步：根据数据量决定获取策略
      let allData = [];
      
      if (totalCount <= 1000) {
        const params2 = {
        ...this.formInline,
        page: 1,
        limit: totalCount
      };
        // 数据量较小，一次性获取
        const res = await exchangeList(params2);
        allData = res.data || [];
      } else {
        // 数据量较大，分页获取
        const pageSize = 100;
        const totalPages = Math.ceil(totalCount / pageSize);
        
        // 提示用户正在获取数据
        const loadingMsg = this.$message.loading(`正在获取数据... 0/${totalPages}页`, 0);
        
        try {
          for (let page = 1; page <= totalPages; page++) {
            const params3 = {
              ...this.formInline,
              page: page,
              limit: pageSize
            }
            const res = await exchangeList(params3);
            if (res.data && res.data.length > 0) {
              allData = allData.concat(res.data);
            }
            // 更新进度提示
            loadingMsg();
            this.$message.loading(`正在获取数据... ${page}/${totalPages}页`, 0);
          }
        } finally {
          loadingMsg();
        }
      }
      
      this.$message.success(`成功获取 ${allData.length} 条数据，开始导出...`);
      return allData;
    },

    topage(routerpath) {
      this.$router.push(routerpath);
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    // 查询
    query() {
      this.loading = true;
      exchangeList(this.formInline).then((res) => {
        this.loading = false;
        this.data = res.data;
        this.pagination.total = res.count;
      });
    },
    // 分页按钮配置
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      exchangeList({ limit: this.pagination.pageSize, page: this.pagination.current }).then((res) => {
        this.data = res.data;
        console.log(res);
        this.loading = false;
      });
    },
    // 确认领取
    exchangeok(row) {
      console.log(row);
      exchangeOk({ orderNo: row.orderNo, orderStatus: 2 }).then((res) => {
        this.getExchangeListData();
        message.success(res.data);
      });
    },
    // 取消领取
    exchangeno(row) {
      exchangeNo({ orderNo: row.orderNo, orderStatus: 1 }).then((res) => {
        this.getExchangeListData();
        message.success(res.data);
      });
    },
    // 分页数据
    getExchangeListData() {
      exchangeList({ limit: 10, page: 1 }).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
        console.log(res);
      });
    },
    showModal() {
      this.visible = true;
    },
    handleOk(e) {
      console.log(e);
      this.visible = false;
    },
  },
};
</script>
<style scoped>
.test {
  position: relative;
  left: 55px;
}
</style>


// WEBPACK FOOTER //
// src/views/orderManagement/exchangeOrderHomeContent.vue